/**
 *  Librairie pour gérer l'autocomplète google
 *  cette library n'est utilisé n'est pour le moment (22/01/2021) utilisé que dans jeux concours.
 *  elle doit:
 *    - permettre de réécrire de manière plus propre ce qui concerne la géolocalisation ( dans les fichiers disko.js et main.js)
 *    - permettre de remplacer les autocomplètes du site par une autre API que google (leaflet ou autre)
 *    - rendre independant la fonctionnalité "Autocomplète" des formulaires du site
 */


/**
 * Utilisation
 *  <input id="myAutocomplete" class="google-autocomplete" value=""></input>
 * 
 *  $(domcument).on("google-autocomplete-changed","",function(event, localisation) {
 *      // Localisation contient les données
 *  });
 * 
 *  window.autocomplete.localisation contient aussi la dernière adresse selectionée
 * 
 */
(function ($) {
    /**
     * Initialise les elements de  type autocomplete
     */
    $.fn.InitGoogleMapAutoComplete = function () {
        var options = {
            componentRestrictions: { country: 'fr' }
        };
        var inputAutocomplete = $(this);
        window.autocomplete = new google.maps.places.Autocomplete($(this)[0], options);
        // Limite les champs retournés par google pour limiter le volume et la facture
        window.autocomplete.setFields(['address_components', 'formatted_address', 'geometry', 'name']);
        window.autocomplete.addListener('place_changed', function () {
            var googleDatas = {};
            const place = autocomplete.getPlace();
            if (!place || !place.geometry || !place.geometry.location) {
                // Place selected without geometry (e.g. user pressed Enter without choosing a suggestion)
                inputAutocomplete.trigger("google-autocomplete-changed", [null]);
                return null;
            }
            googleDatas['lat'] = ('function' == typeof place.geometry.location.lat) ? place.geometry.location.lat() : place.geometry.location.lat;
            googleDatas['lng'] = ('function' == typeof place.geometry.location.lng) ? place.geometry.location.lng() : place.geometry.location.lng;
            googleDatas['formatted_address'] = place.formatted_address;

            var street = '';
            place.address_components.forEach(function (c) {
                switch (c.types[0]) {
                    case 'street_number':
                        street = c.long_name + ' ' + street;
                        break;
                    case 'route':
                        street = street + ' ' + c.long_name;
                        break;
                    case 'neighborhood':
                    case 'locality':
                        googleDatas['city'] = c.long_name;
                        break;
                    case 'administrative_area_level_1':
                        googleDatas['region'] = c.long_name;
                        break;
                    case 'administrative_area_level_2':
                        googleDatas['department'] = c.long_name;
                        break;
                    case 'postal_code':
                        googleDatas['postalCode'] = c.long_name;
                        break;
                }
            });

            googleDatas['address'] = street;
            window.autocomplete.localisation = googleDatas;
            inputAutocomplete.trigger("google-autocomplete-changed", [googleDatas])
            return googleDatas;
        });

        $(inputAutocomplete).on('input', function () {
            window.autocomplete.localisation = null;
        })

        $(this).trigger("google-autocomplete-loaded");
    };

    /**
     * Affecte une localisation à l'autocomplete
     */
    $.fn.SetLocalisation = function (localisation) {
        $(this).val(localisation.formatted_address);
        if (typeof (window.autocomplete) !== 'undefined') {
            window.autocomplete = Object.assign(window.autocomplete, { localisation: localisation });
        } else {
            // Si pas encore crée
            $(this).on("google-autocomplete-loaded", function () {
                window.autocomplete = Object.assign(window.autocomplete, { localisation: localisation });
            })
        }
    }
    /**
     * Initialise les boutons de géolocalisation
     */
    $.fn.InitBoutonGetLocalisationWithGoogle = function () {
        var boutonLocalisation = $(this);
        $(this).on('click', function (event) {
            event.preventDefault();
            if ('geolocation' in navigator) {
                navigator.geolocation.getCurrentPosition(function (position) {

                    var googleDatas = {};
                    googleDatas['lat'] = position.coords.latitude;
                    googleDatas['lng'] = position.coords.longitude;
                    var geolocatedLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                    var geocoder = new google.maps.Geocoder();
                    var inputAutocomplete = boutonLocalisation.closest(".form__controls").find(".google-autocomplete");
                    var boutonRemoveLocation = boutonLocalisation.closest(".form__controls").find(".btn-remove-location");

                    geocoder.geocode({ 'location': geolocatedLatLng }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[0]) {

                                inputAutocomplete.val(results[0].formatted_address);
                                googleDatas['formatted_address'] = results[0].formatted_address;

                                //window.autocomplete.set('place', results[0]);

                                boutonLocalisation.hide();
                                boutonRemoveLocation.show();

                                var street = '';
                                results[0].address_components.forEach(function (c) {
                                    switch (c.types[0]) {
                                        case 'street_number':
                                            street = c.long_name + ' ' + street;
                                            break;
                                        case 'route':
                                            street = street + ' ' + c.long_name;
                                            break;
                                        case 'neighborhood':
                                        case 'locality':
                                            googleDatas['city'] = c.long_name;
                                            break;
                                        case 'administrative_area_level_1':
                                            googleDatas['region'] = c.long_name;
                                            break;
                                        case 'administrative_area_level_2':
                                            googleDatas['department'] = c.long_name;
                                            break;
                                        case 'postal_code':
                                            googleDatas['postalCode'] = c.long_name;
                                            break;
                                    }
                                });

                                googleDatas['address'] = street;
                                window.autocomplete.localisation = googleDatas;
                                inputAutocomplete.trigger("google-autocomplete-changed", [googleDatas])

                            } else {
                                //console.log("No reverse geocode results.");
                            }
                        } else {
                            //console.log("Geocoder failed: " + status);
                        }
                    });
                }, function () {
                    // Erreur callback
                    window.autocomplete.localisation = null;
                    var inputAutocomplete = boutonLocalisation.closest(".form__controls").find(".google-autocomplete");
                    inputAutocomplete.trigger("google-autocomplete-changed", null);
                });
            } else {
                //console.log("Browser doesn't support geolocation!");
            }
        });
    }
    /**
     * Initialise les boutons de suppression de la géolocalisation
     */
    $.fn.InitBoutonSuppressionLocalisation = function () {
        $(this).on('click', function () {
            var boutonSupressionLocalisation = $(this);
            var inputAutocomplete = boutonSupressionLocalisation.closest(".form__controls").find(".google-autocomplete");
            var boutonLocation = boutonSupressionLocalisation.closest(".form__controls").find(".btn-location");
            inputAutocomplete.val('');
            window.autocomplete.localisation = null;
            inputAutocomplete.trigger("google-autocomplete-changed", null);
            boutonSupressionLocalisation.hide();
            boutonLocation.show();
        });
    }

})(jQuery);


/**
 * Cette function est executée lorsque l'API google est chargée
 * cela permet de mettre le script google map en defer async
 */
(function (w) {
    w.googleApiCallBack = function () {
        console.info("Google map est chargé.");

        // Initialise les champs google-autocomplete après le chargement de l'API Google
        jQuery(function () {
            // Champ autocomplete
            jQuery("input.google-autocomplete").each(function (index, element) {
                jQuery(element).InitGoogleMapAutoComplete();
            })
            // Bouton de géolocalisation
            jQuery("button.btn-location").each(function (index, element) {
                jQuery(element).InitBoutonGetLocalisationWithGoogle();
            });
            // Bouton de suppression de la géolocalisation
            jQuery("button.btn-remove-location").each(function (index, element) {
                jQuery(element).InitBoutonSuppressionLocalisation();
            });
        });
    }
})(window);








